/** Problem interstitial: copy deck §3. Two-column: headline left, body right. */
import { Section, Eyebrow } from './Section.js';

export function Problem() {
  return (
    <Section>
      <div className="grid gap-10 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-6">
          <Eyebrow>The problem</Eyebrow>
          <h2 className="mt-4 font-display text-3xl font-bold leading-tight tracking-tight text-slate-900 sm:text-4xl">
            Most cold-email tools are optimized for volume. That&rsquo;s the
            problem.
          </h2>
        </div>
        <div className="lg:col-span-6">
          <p className="text-lg leading-relaxed text-slate-600">
            Blast 10,000 emails from five fresh domains, watch your reply rate,
            move on. It works right up until your bounce rate spikes, the spam
            complaints roll in, and the domain you actually run your business on
            stops landing anywhere. Volume is easy. Keeping your sender
            reputation intact while you do it is the hard part nobody sells.
          </p>
          <p className="mt-6 border-l-2 border-brand-700 pl-4 font-display text-xl font-semibold leading-snug text-slate-900">
            RevBase is built around the hard part.
          </p>
        </div>
      </div>
    </Section>
  );
}
